import { API } from "../api";

const BASE_URL = "/cooperatives/settings/loan-application";

export const loanApplicationSettingsApi = API.injectEndpoints({
  endpoints: (builder) => ({
    getLoanApplicationSettings: builder.query({
      query: () => `${BASE_URL}?guard=staff`,
      transformResponse: (responseData) => responseData?.data,
      providesTags: [{ type: "LoanApplicationSettings", id: "CURRENT" }],
    }),
    updateLoanApplicationSettings: builder.mutation({
      query: (body) => ({
        url: `${BASE_URL}?guard=staff`,
        method: "PUT",
        body,
      }),
      transformResponse: (responseData) => responseData,
      invalidatesTags: [{ type: "LoanApplicationSettings", id: "CURRENT" }],
    }),
  }),
});

export const {
  useGetLoanApplicationSettingsQuery,
  useUpdateLoanApplicationSettingsMutation,
} = loanApplicationSettingsApi;
